export default __webpack_public_path__ + "static/media/image-choiceListTestExample-2000x3000-png.275d9d06.png";